/* eslint-disable */
import Long from "long";
import _m0 from "protobufjs/minimal";
import { Uuid } from "../../gen/uuid_util/uuid";
import { DummyChannelTriggeredActionArgs } from "./complimentary_actions_impls/dummy_channel_triggered/dummy_channel_triggered";
import { DummyTimerTriggeredActionArgs } from "./complimentary_actions_impls/dummy_timer_triggered/dummy_timer_triggered";
import { FaultOverrideOnPolicyChangeActionArgs } from "./complimentary_actions_impls/fault_override_on_policy_change/fault_override_on_policy_change";
import { PublishExecutiveLookAtCommandActionArgs } from "./complimentary_actions_impls/publish_executive_look_at_command/publish_executive_look_at_command";
import { SendMissionControlActionArgs } from "./complimentary_actions_impls/send_mission_control/send_mission_control";
import { SimEventBatteryActionArgs } from "./complimentary_actions_impls/sim_event_battery/sim_event_battery";
import { SimEventPacketlossActionArgs } from "./complimentary_actions_impls/sim_event_packetloss/sim_event_packetloss";
import { SimEventTemperatureActionArgs } from "./complimentary_actions_impls/sim_event_temperature/sim_event_temperature";
import { SimEventWindActionArgs } from "./complimentary_actions_impls/sim_event_wind/sim_event_wind";
import { SpawnComplimentaryActionHook } from "./complimentary_actions_impls/spawn_complimentary_actions_on_hook/spawn_complimentary_actions_on_hook";
import { SpoofMultiDroneActionArgs } from "./complimentary_actions_impls/spoof_multi_drone/spoof_multi_drone";
import { SpoofPhoneInputsActionArgs } from "./complimentary_actions_impls/spoof_phone_inputs/spoof_phone_inputs";
import { SpoofPhotoResponseActionArgs } from "./complimentary_actions_impls/spoof_photo_response/spoof_photo_response";
import { TriggerArgs_ChannelCallback } from "./trigger_args";

export const protobufPackage = "complimentary_actions";

/** Args defining the behavior of a corresponding action type (a-la the MissionAction's ActionArgs) */
export interface ComplimentaryActionArgs {
  dummyTimerTriggered?: DummyTimerTriggeredActionArgs | undefined;
  dummyChannelTriggered?: DummyChannelTriggeredActionArgs | undefined;
  sendMissionControl?: SendMissionControlActionArgs | undefined;
  spawnComplimentaryActionsOnHook?: SpawnComplimentaryActionsOnHookActionArgs | undefined;
  spoofPhotoResponse?: SpoofPhotoResponseActionArgs | undefined;
  publishExecutiveLookAtCommand?: PublishExecutiveLookAtCommandActionArgs | undefined;
  simEventWind?: SimEventWindActionArgs | undefined;
  simEventBattery?: SimEventBatteryActionArgs | undefined;
  simEventPacketloss?: SimEventPacketlossActionArgs | undefined;
  faultOverrideOnPolicyChange?: FaultOverrideOnPolicyChangeActionArgs | undefined;
  spoofMultiDrone?: SpoofMultiDroneActionArgs | undefined;
  spoofPhoneInputs?: SpoofPhoneInputsActionArgs | undefined;
  simEventTemperature?:
    | SimEventTemperatureActionArgs
    | undefined;
  /**
   * Bool that defines whether should be called only once (corresponding to the callback returning
   * True on the first time it is invoked); an assert is hit if this is not the case.
   */
  requireCalledAtMostOnce: boolean;
}

/** The definition of a complimentary action */
export interface ComplimentaryAction {
  /**
   * Uniquely identifies an instance of an action and prevents the same instance from being
   * registered more than once during the lifetime of the ComplimentaryActionsFront in-between
   * transitions to REST.
   */
  uuid:
    | Uuid
    | undefined;
  /** Args defining the behavior of the action. */
  actionArgs: ComplimentaryActionArgs | undefined;
}

/** Type for the REGISTER_COMPLIMENTARY_ACTIONS_PB channel. */
export interface RegisterComplimentaryActions {
  utime: number;
  actionsToRegister: ComplimentaryAction[];
  uclock: number;
}

/** Events published for each action (a-la the MissionAction's ActionEvent) */
export interface ComplimentaryActionEvent {
  utime: number;
  uuid: Uuid | undefined;
  event: ComplimentaryActionEvent_EventType;
  /** action class name */
  name: string;
}

export enum ComplimentaryActionEvent_EventType {
  INVALID = 0,
  REGISTERED = 1,
  FIRST_TRIGGER = 2,
  DONE = 3,
  UNRECOGNIZED = -1,
}

export function complimentaryActionEvent_EventTypeFromJSON(object: any): ComplimentaryActionEvent_EventType {
  switch (object) {
    case 0:
    case "INVALID":
      return ComplimentaryActionEvent_EventType.INVALID;
    case 1:
    case "REGISTERED":
      return ComplimentaryActionEvent_EventType.REGISTERED;
    case 2:
    case "FIRST_TRIGGER":
      return ComplimentaryActionEvent_EventType.FIRST_TRIGGER;
    case 3:
    case "DONE":
      return ComplimentaryActionEvent_EventType.DONE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ComplimentaryActionEvent_EventType.UNRECOGNIZED;
  }
}

export function complimentaryActionEvent_EventTypeToJSON(object: ComplimentaryActionEvent_EventType): string {
  switch (object) {
    case ComplimentaryActionEvent_EventType.INVALID:
      return "INVALID";
    case ComplimentaryActionEvent_EventType.REGISTERED:
      return "REGISTERED";
    case ComplimentaryActionEvent_EventType.FIRST_TRIGGER:
      return "FIRST_TRIGGER";
    case ComplimentaryActionEvent_EventType.DONE:
      return "DONE";
    case ComplimentaryActionEvent_EventType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/**
 * NOTE: This is defined here to avoid circular imports, as opposed to in
 * spawn_complimentary_actions_on_hook.proto where it would otherwise be.
 */
export interface SpawnComplimentaryActionsOnHookActionArgs {
  trigger:
    | TriggerArgs_ChannelCallback
    | undefined;
  /** When to spawn (register) the child actions */
  hook:
    | SpawnComplimentaryActionHook
    | undefined;
  /** Child actions to spawn (regster) */
  childActions: ComplimentaryAction[];
}

function createBaseComplimentaryActionArgs(): ComplimentaryActionArgs {
  return {
    dummyTimerTriggered: undefined,
    dummyChannelTriggered: undefined,
    sendMissionControl: undefined,
    spawnComplimentaryActionsOnHook: undefined,
    spoofPhotoResponse: undefined,
    publishExecutiveLookAtCommand: undefined,
    simEventWind: undefined,
    simEventBattery: undefined,
    simEventPacketloss: undefined,
    faultOverrideOnPolicyChange: undefined,
    spoofMultiDrone: undefined,
    spoofPhoneInputs: undefined,
    simEventTemperature: undefined,
    requireCalledAtMostOnce: false,
  };
}

export const ComplimentaryActionArgs = {
  encode(message: ComplimentaryActionArgs, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.dummyTimerTriggered !== undefined) {
      DummyTimerTriggeredActionArgs.encode(message.dummyTimerTriggered, writer.uint32(18).fork()).ldelim();
    }
    if (message.dummyChannelTriggered !== undefined) {
      DummyChannelTriggeredActionArgs.encode(message.dummyChannelTriggered, writer.uint32(26).fork()).ldelim();
    }
    if (message.sendMissionControl !== undefined) {
      SendMissionControlActionArgs.encode(message.sendMissionControl, writer.uint32(34).fork()).ldelim();
    }
    if (message.spawnComplimentaryActionsOnHook !== undefined) {
      SpawnComplimentaryActionsOnHookActionArgs.encode(
        message.spawnComplimentaryActionsOnHook,
        writer.uint32(42).fork(),
      ).ldelim();
    }
    if (message.spoofPhotoResponse !== undefined) {
      SpoofPhotoResponseActionArgs.encode(message.spoofPhotoResponse, writer.uint32(50).fork()).ldelim();
    }
    if (message.publishExecutiveLookAtCommand !== undefined) {
      PublishExecutiveLookAtCommandActionArgs.encode(message.publishExecutiveLookAtCommand, writer.uint32(58).fork())
        .ldelim();
    }
    if (message.simEventWind !== undefined) {
      SimEventWindActionArgs.encode(message.simEventWind, writer.uint32(66).fork()).ldelim();
    }
    if (message.simEventBattery !== undefined) {
      SimEventBatteryActionArgs.encode(message.simEventBattery, writer.uint32(74).fork()).ldelim();
    }
    if (message.simEventPacketloss !== undefined) {
      SimEventPacketlossActionArgs.encode(message.simEventPacketloss, writer.uint32(82).fork()).ldelim();
    }
    if (message.faultOverrideOnPolicyChange !== undefined) {
      FaultOverrideOnPolicyChangeActionArgs.encode(message.faultOverrideOnPolicyChange, writer.uint32(90).fork())
        .ldelim();
    }
    if (message.spoofMultiDrone !== undefined) {
      SpoofMultiDroneActionArgs.encode(message.spoofMultiDrone, writer.uint32(98).fork()).ldelim();
    }
    if (message.spoofPhoneInputs !== undefined) {
      SpoofPhoneInputsActionArgs.encode(message.spoofPhoneInputs, writer.uint32(106).fork()).ldelim();
    }
    if (message.simEventTemperature !== undefined) {
      SimEventTemperatureActionArgs.encode(message.simEventTemperature, writer.uint32(114).fork()).ldelim();
    }
    if (message.requireCalledAtMostOnce === true) {
      writer.uint32(8).bool(message.requireCalledAtMostOnce);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ComplimentaryActionArgs {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseComplimentaryActionArgs();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2:
          if (tag !== 18) {
            break;
          }

          message.dummyTimerTriggered = DummyTimerTriggeredActionArgs.decode(reader, reader.uint32());
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.dummyChannelTriggered = DummyChannelTriggeredActionArgs.decode(reader, reader.uint32());
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.sendMissionControl = SendMissionControlActionArgs.decode(reader, reader.uint32());
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.spawnComplimentaryActionsOnHook = SpawnComplimentaryActionsOnHookActionArgs.decode(
            reader,
            reader.uint32(),
          );
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.spoofPhotoResponse = SpoofPhotoResponseActionArgs.decode(reader, reader.uint32());
          continue;
        case 7:
          if (tag !== 58) {
            break;
          }

          message.publishExecutiveLookAtCommand = PublishExecutiveLookAtCommandActionArgs.decode(
            reader,
            reader.uint32(),
          );
          continue;
        case 8:
          if (tag !== 66) {
            break;
          }

          message.simEventWind = SimEventWindActionArgs.decode(reader, reader.uint32());
          continue;
        case 9:
          if (tag !== 74) {
            break;
          }

          message.simEventBattery = SimEventBatteryActionArgs.decode(reader, reader.uint32());
          continue;
        case 10:
          if (tag !== 82) {
            break;
          }

          message.simEventPacketloss = SimEventPacketlossActionArgs.decode(reader, reader.uint32());
          continue;
        case 11:
          if (tag !== 90) {
            break;
          }

          message.faultOverrideOnPolicyChange = FaultOverrideOnPolicyChangeActionArgs.decode(reader, reader.uint32());
          continue;
        case 12:
          if (tag !== 98) {
            break;
          }

          message.spoofMultiDrone = SpoofMultiDroneActionArgs.decode(reader, reader.uint32());
          continue;
        case 13:
          if (tag !== 106) {
            break;
          }

          message.spoofPhoneInputs = SpoofPhoneInputsActionArgs.decode(reader, reader.uint32());
          continue;
        case 14:
          if (tag !== 114) {
            break;
          }

          message.simEventTemperature = SimEventTemperatureActionArgs.decode(reader, reader.uint32());
          continue;
        case 1:
          if (tag !== 8) {
            break;
          }

          message.requireCalledAtMostOnce = reader.bool();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ComplimentaryActionArgs {
    return {
      dummyTimerTriggered: isSet(object.dummyTimerTriggered)
        ? DummyTimerTriggeredActionArgs.fromJSON(object.dummyTimerTriggered)
        : undefined,
      dummyChannelTriggered: isSet(object.dummyChannelTriggered)
        ? DummyChannelTriggeredActionArgs.fromJSON(object.dummyChannelTriggered)
        : undefined,
      sendMissionControl: isSet(object.sendMissionControl)
        ? SendMissionControlActionArgs.fromJSON(object.sendMissionControl)
        : undefined,
      spawnComplimentaryActionsOnHook: isSet(object.spawnComplimentaryActionsOnHook)
        ? SpawnComplimentaryActionsOnHookActionArgs.fromJSON(object.spawnComplimentaryActionsOnHook)
        : undefined,
      spoofPhotoResponse: isSet(object.spoofPhotoResponse)
        ? SpoofPhotoResponseActionArgs.fromJSON(object.spoofPhotoResponse)
        : undefined,
      publishExecutiveLookAtCommand: isSet(object.publishExecutiveLookAtCommand)
        ? PublishExecutiveLookAtCommandActionArgs.fromJSON(object.publishExecutiveLookAtCommand)
        : undefined,
      simEventWind: isSet(object.simEventWind) ? SimEventWindActionArgs.fromJSON(object.simEventWind) : undefined,
      simEventBattery: isSet(object.simEventBattery)
        ? SimEventBatteryActionArgs.fromJSON(object.simEventBattery)
        : undefined,
      simEventPacketloss: isSet(object.simEventPacketloss)
        ? SimEventPacketlossActionArgs.fromJSON(object.simEventPacketloss)
        : undefined,
      faultOverrideOnPolicyChange: isSet(object.faultOverrideOnPolicyChange)
        ? FaultOverrideOnPolicyChangeActionArgs.fromJSON(object.faultOverrideOnPolicyChange)
        : undefined,
      spoofMultiDrone: isSet(object.spoofMultiDrone)
        ? SpoofMultiDroneActionArgs.fromJSON(object.spoofMultiDrone)
        : undefined,
      spoofPhoneInputs: isSet(object.spoofPhoneInputs)
        ? SpoofPhoneInputsActionArgs.fromJSON(object.spoofPhoneInputs)
        : undefined,
      simEventTemperature: isSet(object.simEventTemperature)
        ? SimEventTemperatureActionArgs.fromJSON(object.simEventTemperature)
        : undefined,
      requireCalledAtMostOnce: isSet(object.requireCalledAtMostOnce)
        ? globalThis.Boolean(object.requireCalledAtMostOnce)
        : false,
    };
  },

  toJSON(message: ComplimentaryActionArgs): unknown {
    const obj: any = {};
    if (message.dummyTimerTriggered !== undefined) {
      obj.dummyTimerTriggered = DummyTimerTriggeredActionArgs.toJSON(message.dummyTimerTriggered);
    }
    if (message.dummyChannelTriggered !== undefined) {
      obj.dummyChannelTriggered = DummyChannelTriggeredActionArgs.toJSON(message.dummyChannelTriggered);
    }
    if (message.sendMissionControl !== undefined) {
      obj.sendMissionControl = SendMissionControlActionArgs.toJSON(message.sendMissionControl);
    }
    if (message.spawnComplimentaryActionsOnHook !== undefined) {
      obj.spawnComplimentaryActionsOnHook = SpawnComplimentaryActionsOnHookActionArgs.toJSON(
        message.spawnComplimentaryActionsOnHook,
      );
    }
    if (message.spoofPhotoResponse !== undefined) {
      obj.spoofPhotoResponse = SpoofPhotoResponseActionArgs.toJSON(message.spoofPhotoResponse);
    }
    if (message.publishExecutiveLookAtCommand !== undefined) {
      obj.publishExecutiveLookAtCommand = PublishExecutiveLookAtCommandActionArgs.toJSON(
        message.publishExecutiveLookAtCommand,
      );
    }
    if (message.simEventWind !== undefined) {
      obj.simEventWind = SimEventWindActionArgs.toJSON(message.simEventWind);
    }
    if (message.simEventBattery !== undefined) {
      obj.simEventBattery = SimEventBatteryActionArgs.toJSON(message.simEventBattery);
    }
    if (message.simEventPacketloss !== undefined) {
      obj.simEventPacketloss = SimEventPacketlossActionArgs.toJSON(message.simEventPacketloss);
    }
    if (message.faultOverrideOnPolicyChange !== undefined) {
      obj.faultOverrideOnPolicyChange = FaultOverrideOnPolicyChangeActionArgs.toJSON(
        message.faultOverrideOnPolicyChange,
      );
    }
    if (message.spoofMultiDrone !== undefined) {
      obj.spoofMultiDrone = SpoofMultiDroneActionArgs.toJSON(message.spoofMultiDrone);
    }
    if (message.spoofPhoneInputs !== undefined) {
      obj.spoofPhoneInputs = SpoofPhoneInputsActionArgs.toJSON(message.spoofPhoneInputs);
    }
    if (message.simEventTemperature !== undefined) {
      obj.simEventTemperature = SimEventTemperatureActionArgs.toJSON(message.simEventTemperature);
    }
    if (message.requireCalledAtMostOnce === true) {
      obj.requireCalledAtMostOnce = message.requireCalledAtMostOnce;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ComplimentaryActionArgs>, I>>(base?: I): ComplimentaryActionArgs {
    return ComplimentaryActionArgs.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ComplimentaryActionArgs>, I>>(object: I): ComplimentaryActionArgs {
    const message = createBaseComplimentaryActionArgs();
    message.dummyTimerTriggered = (object.dummyTimerTriggered !== undefined && object.dummyTimerTriggered !== null)
      ? DummyTimerTriggeredActionArgs.fromPartial(object.dummyTimerTriggered)
      : undefined;
    message.dummyChannelTriggered =
      (object.dummyChannelTriggered !== undefined && object.dummyChannelTriggered !== null)
        ? DummyChannelTriggeredActionArgs.fromPartial(object.dummyChannelTriggered)
        : undefined;
    message.sendMissionControl = (object.sendMissionControl !== undefined && object.sendMissionControl !== null)
      ? SendMissionControlActionArgs.fromPartial(object.sendMissionControl)
      : undefined;
    message.spawnComplimentaryActionsOnHook =
      (object.spawnComplimentaryActionsOnHook !== undefined && object.spawnComplimentaryActionsOnHook !== null)
        ? SpawnComplimentaryActionsOnHookActionArgs.fromPartial(object.spawnComplimentaryActionsOnHook)
        : undefined;
    message.spoofPhotoResponse = (object.spoofPhotoResponse !== undefined && object.spoofPhotoResponse !== null)
      ? SpoofPhotoResponseActionArgs.fromPartial(object.spoofPhotoResponse)
      : undefined;
    message.publishExecutiveLookAtCommand =
      (object.publishExecutiveLookAtCommand !== undefined && object.publishExecutiveLookAtCommand !== null)
        ? PublishExecutiveLookAtCommandActionArgs.fromPartial(object.publishExecutiveLookAtCommand)
        : undefined;
    message.simEventWind = (object.simEventWind !== undefined && object.simEventWind !== null)
      ? SimEventWindActionArgs.fromPartial(object.simEventWind)
      : undefined;
    message.simEventBattery = (object.simEventBattery !== undefined && object.simEventBattery !== null)
      ? SimEventBatteryActionArgs.fromPartial(object.simEventBattery)
      : undefined;
    message.simEventPacketloss = (object.simEventPacketloss !== undefined && object.simEventPacketloss !== null)
      ? SimEventPacketlossActionArgs.fromPartial(object.simEventPacketloss)
      : undefined;
    message.faultOverrideOnPolicyChange =
      (object.faultOverrideOnPolicyChange !== undefined && object.faultOverrideOnPolicyChange !== null)
        ? FaultOverrideOnPolicyChangeActionArgs.fromPartial(object.faultOverrideOnPolicyChange)
        : undefined;
    message.spoofMultiDrone = (object.spoofMultiDrone !== undefined && object.spoofMultiDrone !== null)
      ? SpoofMultiDroneActionArgs.fromPartial(object.spoofMultiDrone)
      : undefined;
    message.spoofPhoneInputs = (object.spoofPhoneInputs !== undefined && object.spoofPhoneInputs !== null)
      ? SpoofPhoneInputsActionArgs.fromPartial(object.spoofPhoneInputs)
      : undefined;
    message.simEventTemperature = (object.simEventTemperature !== undefined && object.simEventTemperature !== null)
      ? SimEventTemperatureActionArgs.fromPartial(object.simEventTemperature)
      : undefined;
    message.requireCalledAtMostOnce = object.requireCalledAtMostOnce ?? false;
    return message;
  },
};

function createBaseComplimentaryAction(): ComplimentaryAction {
  return { uuid: undefined, actionArgs: undefined };
}

export const ComplimentaryAction = {
  encode(message: ComplimentaryAction, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.uuid !== undefined) {
      Uuid.encode(message.uuid, writer.uint32(10).fork()).ldelim();
    }
    if (message.actionArgs !== undefined) {
      ComplimentaryActionArgs.encode(message.actionArgs, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ComplimentaryAction {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseComplimentaryAction();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.uuid = Uuid.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.actionArgs = ComplimentaryActionArgs.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ComplimentaryAction {
    return {
      uuid: isSet(object.uuid) ? Uuid.fromJSON(object.uuid) : undefined,
      actionArgs: isSet(object.actionArgs) ? ComplimentaryActionArgs.fromJSON(object.actionArgs) : undefined,
    };
  },

  toJSON(message: ComplimentaryAction): unknown {
    const obj: any = {};
    if (message.uuid !== undefined) {
      obj.uuid = Uuid.toJSON(message.uuid);
    }
    if (message.actionArgs !== undefined) {
      obj.actionArgs = ComplimentaryActionArgs.toJSON(message.actionArgs);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ComplimentaryAction>, I>>(base?: I): ComplimentaryAction {
    return ComplimentaryAction.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ComplimentaryAction>, I>>(object: I): ComplimentaryAction {
    const message = createBaseComplimentaryAction();
    message.uuid = (object.uuid !== undefined && object.uuid !== null) ? Uuid.fromPartial(object.uuid) : undefined;
    message.actionArgs = (object.actionArgs !== undefined && object.actionArgs !== null)
      ? ComplimentaryActionArgs.fromPartial(object.actionArgs)
      : undefined;
    return message;
  },
};

function createBaseRegisterComplimentaryActions(): RegisterComplimentaryActions {
  return { utime: 0, actionsToRegister: [], uclock: 0 };
}

export const RegisterComplimentaryActions = {
  encode(message: RegisterComplimentaryActions, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.utime !== 0) {
      writer.uint32(8).int64(message.utime);
    }
    for (const v of message.actionsToRegister) {
      ComplimentaryAction.encode(v!, writer.uint32(18).fork()).ldelim();
    }
    if (message.uclock !== 0) {
      writer.uint32(24).int64(message.uclock);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): RegisterComplimentaryActions {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRegisterComplimentaryActions();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.utime = longToNumber(reader.int64() as Long);
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.actionsToRegister.push(ComplimentaryAction.decode(reader, reader.uint32()));
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.uclock = longToNumber(reader.int64() as Long);
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RegisterComplimentaryActions {
    return {
      utime: isSet(object.utime) ? globalThis.Number(object.utime) : 0,
      actionsToRegister: globalThis.Array.isArray(object?.actionsToRegister)
        ? object.actionsToRegister.map((e: any) => ComplimentaryAction.fromJSON(e))
        : [],
      uclock: isSet(object.uclock) ? globalThis.Number(object.uclock) : 0,
    };
  },

  toJSON(message: RegisterComplimentaryActions): unknown {
    const obj: any = {};
    if (message.utime !== 0) {
      obj.utime = Math.round(message.utime);
    }
    if (message.actionsToRegister?.length) {
      obj.actionsToRegister = message.actionsToRegister.map((e) => ComplimentaryAction.toJSON(e));
    }
    if (message.uclock !== 0) {
      obj.uclock = Math.round(message.uclock);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RegisterComplimentaryActions>, I>>(base?: I): RegisterComplimentaryActions {
    return RegisterComplimentaryActions.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RegisterComplimentaryActions>, I>>(object: I): RegisterComplimentaryActions {
    const message = createBaseRegisterComplimentaryActions();
    message.utime = object.utime ?? 0;
    message.actionsToRegister = object.actionsToRegister?.map((e) => ComplimentaryAction.fromPartial(e)) || [];
    message.uclock = object.uclock ?? 0;
    return message;
  },
};

function createBaseComplimentaryActionEvent(): ComplimentaryActionEvent {
  return { utime: 0, uuid: undefined, event: 0, name: "" };
}

export const ComplimentaryActionEvent = {
  encode(message: ComplimentaryActionEvent, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.utime !== 0) {
      writer.uint32(8).int64(message.utime);
    }
    if (message.uuid !== undefined) {
      Uuid.encode(message.uuid, writer.uint32(18).fork()).ldelim();
    }
    if (message.event !== 0) {
      writer.uint32(24).int32(message.event);
    }
    if (message.name !== "") {
      writer.uint32(34).string(message.name);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ComplimentaryActionEvent {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseComplimentaryActionEvent();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.utime = longToNumber(reader.int64() as Long);
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.uuid = Uuid.decode(reader, reader.uint32());
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.event = reader.int32() as any;
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.name = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ComplimentaryActionEvent {
    return {
      utime: isSet(object.utime) ? globalThis.Number(object.utime) : 0,
      uuid: isSet(object.uuid) ? Uuid.fromJSON(object.uuid) : undefined,
      event: isSet(object.event) ? complimentaryActionEvent_EventTypeFromJSON(object.event) : 0,
      name: isSet(object.name) ? globalThis.String(object.name) : "",
    };
  },

  toJSON(message: ComplimentaryActionEvent): unknown {
    const obj: any = {};
    if (message.utime !== 0) {
      obj.utime = Math.round(message.utime);
    }
    if (message.uuid !== undefined) {
      obj.uuid = Uuid.toJSON(message.uuid);
    }
    if (message.event !== 0) {
      obj.event = complimentaryActionEvent_EventTypeToJSON(message.event);
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ComplimentaryActionEvent>, I>>(base?: I): ComplimentaryActionEvent {
    return ComplimentaryActionEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ComplimentaryActionEvent>, I>>(object: I): ComplimentaryActionEvent {
    const message = createBaseComplimentaryActionEvent();
    message.utime = object.utime ?? 0;
    message.uuid = (object.uuid !== undefined && object.uuid !== null) ? Uuid.fromPartial(object.uuid) : undefined;
    message.event = object.event ?? 0;
    message.name = object.name ?? "";
    return message;
  },
};

function createBaseSpawnComplimentaryActionsOnHookActionArgs(): SpawnComplimentaryActionsOnHookActionArgs {
  return { trigger: undefined, hook: undefined, childActions: [] };
}

export const SpawnComplimentaryActionsOnHookActionArgs = {
  encode(message: SpawnComplimentaryActionsOnHookActionArgs, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.trigger !== undefined) {
      TriggerArgs_ChannelCallback.encode(message.trigger, writer.uint32(10).fork()).ldelim();
    }
    if (message.hook !== undefined) {
      SpawnComplimentaryActionHook.encode(message.hook, writer.uint32(18).fork()).ldelim();
    }
    for (const v of message.childActions) {
      ComplimentaryAction.encode(v!, writer.uint32(26).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SpawnComplimentaryActionsOnHookActionArgs {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSpawnComplimentaryActionsOnHookActionArgs();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.trigger = TriggerArgs_ChannelCallback.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.hook = SpawnComplimentaryActionHook.decode(reader, reader.uint32());
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.childActions.push(ComplimentaryAction.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SpawnComplimentaryActionsOnHookActionArgs {
    return {
      trigger: isSet(object.trigger) ? TriggerArgs_ChannelCallback.fromJSON(object.trigger) : undefined,
      hook: isSet(object.hook) ? SpawnComplimentaryActionHook.fromJSON(object.hook) : undefined,
      childActions: globalThis.Array.isArray(object?.childActions)
        ? object.childActions.map((e: any) => ComplimentaryAction.fromJSON(e))
        : [],
    };
  },

  toJSON(message: SpawnComplimentaryActionsOnHookActionArgs): unknown {
    const obj: any = {};
    if (message.trigger !== undefined) {
      obj.trigger = TriggerArgs_ChannelCallback.toJSON(message.trigger);
    }
    if (message.hook !== undefined) {
      obj.hook = SpawnComplimentaryActionHook.toJSON(message.hook);
    }
    if (message.childActions?.length) {
      obj.childActions = message.childActions.map((e) => ComplimentaryAction.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SpawnComplimentaryActionsOnHookActionArgs>, I>>(
    base?: I,
  ): SpawnComplimentaryActionsOnHookActionArgs {
    return SpawnComplimentaryActionsOnHookActionArgs.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SpawnComplimentaryActionsOnHookActionArgs>, I>>(
    object: I,
  ): SpawnComplimentaryActionsOnHookActionArgs {
    const message = createBaseSpawnComplimentaryActionsOnHookActionArgs();
    message.trigger = (object.trigger !== undefined && object.trigger !== null)
      ? TriggerArgs_ChannelCallback.fromPartial(object.trigger)
      : undefined;
    message.hook = (object.hook !== undefined && object.hook !== null)
      ? SpawnComplimentaryActionHook.fromPartial(object.hook)
      : undefined;
    message.childActions = object.childActions?.map((e) => ComplimentaryAction.fromPartial(e)) || [];
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(long: Long): number {
  if (long.gt(globalThis.Number.MAX_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  return long.toNumber();
}

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
